import { t } from "@/i18n-js/instance";
import { Icon } from "@/react/components/shared/Icon";
import { IconButton } from "@circle-react-shared/uikit/HeaderV3/IconButton";

interface DisabledNoticeProps {
  disabled: boolean;
  onUndo: () => void;
}

const LOCALE_ROOT = "post.conversation_summary";

export const DisabledNotice = ({ onUndo, disabled }: DisabledNoticeProps) => (
  <div className="bg-tertiary group flex items-center justify-between rounded-md p-4">
    <div className="flex items-center gap-1">
      <Icon type="20-stardust" size={20} className="text-default !h-5 !w-5" />
      <span className="text-dark text-sm font-normal normal-case leading-5 tracking-tight">
        {t([LOCALE_ROOT, "disabled_notice"])}
      </span>
    </div>
    <IconButton
      name="20-undo"
      ariaLabel={t([LOCALE_ROOT, "actions", "undo"])}
      tooltipText={t([LOCALE_ROOT, "actions", "undo"])}
      onClick={onUndo}
      className="text-dark"
      iconSize={20}
      buttonSize={24}
      disabled={disabled}
    />
  </div>
);
